if ($('.slider')[0]) {
    $('.slider__items').responsiveSlides({
        speed: 800,
        timeout: 5000,
        pager: true,
        nav: false,
    });
}
